import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/unidriver-core';
import { ModalPreviewLayoutSkin } from '.';

export interface ModalPreviewLayoutUniDriver extends BaseUniDriver {
  clickOverlay: () => Promise<void>;
  getPreviewTitle: () => UniDriver;
  getPreviewActions: () => UniDriver;
  getPreviewContent: () => UniDriver;
  clickClose: () => Promise<void>;
  getSkin: () => Promise<ModalPreviewLayoutSkin>;
}
